import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { CustomLoader } from '../../../../components/custom-loader';

const AutoparkTransportInfoTable = ({ columns, rows, isTableDataLoading }) => {
	if (isTableDataLoading) {
		return <CustomLoader />;
	}

	return (
		<div className="autopark-transport-info-table">
			<Table basic="very" className="autopark-transport-info-table__table">
				<Table.Body>
					{rows?.map(row => {
						if (row.group) {
							return (
								<Table.Row key={row.group} className="autopark-transport-info-table__table-group-title">
									<Table.Cell colSpan="2">{row.group}</Table.Cell>
								</Table.Row>
							);
						}

						return (
							<Table.Row key={row.id} className="autopark-transport-info-table__table-row">
								{columns.map(({ id, customComponent: CustomComponent }) => {
									if (CustomComponent) {
										return (
											<Table.Cell key={id} className="autopark-transport-info-table__table-cell">
												<CustomComponent rowData={row} columnId={id} />
											</Table.Cell>
										);
									}

									return (
										<Table.Cell key={id} className="autopark-transport-info-table__table-cell">
											{row[id]}
										</Table.Cell>
									);
								})}
							</Table.Row>
						);
					})}
				</Table.Body>
			</Table>
		</div>
	);
};

AutoparkTransportInfoTable.propTypes = {
	isTableDataLoading: PropTypes.bool.isRequired,
	columns: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			customComponent: PropTypes.elementType,
		}),
	),
	rows: PropTypes.arrayOf(
		PropTypes.objectOf(
			PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array, PropTypes.number]),
		),
	),
};

export { AutoparkTransportInfoTable };
